<template>
  <div>
    <h4>{{ $t('demolition-residential-du') }}</h4>
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th rowspan="2" scope="col">{{ $t('summary') }}</th>
          <th colspan="5" scope="col">{{ $t('month') }}</th>
          <th colspan="5" scope="col">{{ $t('year-to-date') }}</th>
        </tr>
        <tr>
          <th scope="col">{{ $t('single') }}</th>
          <th scope="col">{{ $t('semi') }}</th>
          <th scope="col">{{ $t('row') }}</th>
          <th scope="col">{{ $t('apt') }}</th>
          <th scope="col">{{ $t('total') }}</th>
          <th scope="col">{{ $t('single') }}</th>
          <th scope="col">{{ $t('semi') }}</th>
          <th scope="col">{{ $t('row') }}</th>
          <th scope="col">{{ $t('apt') }}</th>
          <th scope="col">{{ $t('total') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">{{ $t('total') }}</th>
          <td>{{ singleRecord.curr_mon_total }}</td>
          <td>{{ semiRecord.curr_mon_total }}</td>
          <td>{{ rowRecord.curr_mon_total }}</td>
          <td>{{ aptRecord.curr_mon_total }}</td>
          <td>{{ total.curr_mon_total }}</td>
          <td>{{ singleRecord.curr_ytd_total }}</td>
          <td>{{ semiRecord.curr_ytd_total }}</td>
          <td>{{ rowRecord.curr_ytd_total }}</td>
          <td>{{ aptRecord.curr_ytd_total }}</td>
          <td>{{ total.curr_ytd_total }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('percent-total') }}</th>
          <td>{{ total.mon_single_pct_of_total }}%</td>
          <td>{{ total.mon_semi_pct_of_total }}%</td>
          <td>{{ total.mon_row_pct_of_total }}%</td>
          <td>{{ total.mon_apt_pct_of_total }}%</td>
          <td>{{ total.mon_total_pct_of_total }}%</td>
          <td>{{ total.ytd_single_pct_of_total }}%</td>
          <td>{{ total.ytd_semi_pct_of_total }}%</td>
          <td>{{ total.ytd_row_pct_of_total }}%</td>
          <td>{{ total.ytd_apt_pct_of_total }}%</td>
          <td>{{ total.ytd_total_pct_of_total }}%</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total') }}, {{ lastYear }}</th>
          <td>{{ singleRecord.prev_mon_total }}</td>
          <td>{{ semiRecord.prev_mon_total }}</td>
          <td>{{ rowRecord.prev_mon_total }}</td>
          <td>{{ aptRecord.prev_mon_total }}</td>
          <td>{{ total.prev_mon_total }}</td>
          <td>{{ singleRecord.prev_ytd_total }}</td>
          <td>{{ semiRecord.prev_ytd_total }}</td>
          <td>{{ rowRecord.prev_ytd_total }}</td>
          <td>{{ aptRecord.prev_ytd_total }}</td>
          <td>{{ total.prev_ytd_total }}</td>
        </tr>
        <tr>
          <th>{{ $t('change') }}</th>
          <td>{{ singleRecord.mon_pct_change }}%</td>
          <td>{{ semiRecord.mon_pct_change }}%</td>
          <td>{{ rowRecord.mon_pct_change }}%</td>
          <td>{{ aptRecord.mon_pct_change }}%</td>
          <td>{{ total.mon_pct_change }}%</td>
          <td>{{ singleRecord.ytd_pct_change }}%</td>
          <td>{{ semiRecord.ytd_pct_change }}%</td>
          <td>{{ rowRecord.ytd_pct_change }}%</td>
          <td>{{ aptRecord.ytd_pct_change }}%</td>
          <td>{{ total.ytd_pct_change }}%</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "DemolitionTable",
  data() {
    return {
      response14: [],
      response15: [],
    }
  },

  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;

      // Demolition of Residential Dwelling Units
      // Total
      const request14 = axios.get(
        `https://data.winnipeg.ca/resource/kdey-aemp.json?$select=demolition_building_type, sum(case(issue_date='${endDate}',dwelling_units_lost,true,0)) as curr_mon_total, sum(case(issue_date='${startDate}',dwelling_units_lost,true,0)) as prev_mon_total, case(sum(case(issue_date='${startDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))/sum(case(issue_date='${startDate}',dwelling_units_lost,true,0))-1),0)) as mon_pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0)) as curr_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0)) as prev_ytd_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0))-1),0)) as ytd_pct_change&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}') and demolition_building_type in ('Single','Semi','Row','Apartment')&$group=demolition_building_type`
      );
      // Percentage of Totals
      const request15 = axios.get(
        `https://data.winnipeg.ca/resource/kdey-aemp.json?$select=case(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and demolition_building_type='Single',dwelling_units_lost,true,0))/sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))),0)) as mon_single_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and demolition_building_type='Semi',dwelling_units_lost,true,0))/sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))),0)) as mon_semi_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and demolition_building_type='Row',dwelling_units_lost,true,0))/sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))),0)) as mon_row_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}' and demolition_building_type='Apartment',dwelling_units_lost,true,0))/sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))),0)) as mon_apt_pct_of_total, case(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))/sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))),0)) as mon_total_pct_of_total, sum(case(issue_date='${endDate}',dwelling_units_lost,true,0)) as curr_mon_total, sum(case(issue_date='${startDate}',dwelling_units_lost,true,0)) as prev_mon_total, case(sum(case(issue_date='${startDate}',dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}',dwelling_units_lost,true,0))/sum(case(issue_date='${startDate}',dwelling_units_lost,true,0))-1),0)) as mon_pct_change,  case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and demolition_building_type='Single',dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))),0)) as ytd_single_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and demolition_building_type='Semi',dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))),0)) as ytd_semi_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and demolition_building_type='Row',dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))),0)) as ytd_row_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}') and demolition_building_type='Apartment',dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))),0)) as ytd_apt_pct_of_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))),0)) as ytd_total_pct_of_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0)) as curr_ytd_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0)) as prev_ytd_total, case(sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0))=0,0,true,round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),dwelling_units_lost,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),dwelling_units_lost,true,0))-1),0)) as ytd_pct_change&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}') and demolition_building_type in ('Single','Semi','Row','Apartment')`
      );

      const self = this;
      axios
        .all([
          request14,
          request15,
        ])
        .then(
          axios.spread(function (
            response14,
            response15,
          ) {
            self.response14 = response14.data;
            self.response15 = response15.data;
          })
        );
    }
  },

  computed: {
    lastYear() {
      return parseInt(this.curYear) - 1;
    },

    defaultRecord() {
      return {
        curr_mon_total: "",
        curr_ytd_total: "",
        mon_pct_change: "",
        prev_mon_total: "",
        prev_ytd_total: "",
        ytd_pct_change: "",
      };
    },

    singleRecord() {
      if (this.response14.length === 0) return this.defaultRecord;
      const record = this.response14.find(
        (item) => item.demolition_building_type === "Single"
      );
      return record || this.defaultRecord;
    },
    semiRecord() {
      if (this.response14.length === 0) return this.defaultRecord;
      const record = this.response14.find(
        (item) => item.demolition_building_type === "Semi"
      );
      return record || this.defaultRecord;
    },
    rowRecord() {
      if (this.response14.length === 0) return this.defaultRecord;
      const record = this.response14.find(
        (item) => item.demolition_building_type === "Row"
      );
      return record || this.defaultRecord;
    },
    aptRecord() {
      if (this.response14.length === 0) return this.defaultRecord;
      const record = this.response14.find(
        (item) => item.demolition_building_type === "Apartment"
      );
      return record || this.defaultRecord;
    },
    total() {
      if (this.response15.length === 0)
        return {
          curr_mon_total: "",
          curr_ytd_total: "",
          mon_apt_pct_of_total: "",
          mon_pct_change: "",
          mon_row_pct_of_total: "",
          mon_semi_pct_of_total: "",
          mon_single_pct_of_total: "",
          mon_total_pct_of_total: "",
          prev_mon_total: "",
          prev_ytd_total: "",
          ytd_apt_pct_of_total: "",
          ytd_pct_change: "",
          ytd_row_pct_of_total: "",
          ytd_semi_pct_of_total: "",
          ytd_single_pct_of_total: "",
          ytd_total_pct_of_total: "",
        };
      return this.response15[0];
    },
  },
};
</script>
